import * as z from "zod/v4";
import { enum as zodEnum } from "zod/v4";

const OrderItemUpdateSchema = z.object({
  variantId: z.string(),
  quantity: z.number().min(0),
  action: zodEnum(["add", "remove"]),
});

export const ConfirmUpdateOrderSchema = z.object({
  items: z.array(OrderItemUpdateSchema),
  orderId: z.string(),
});

export type ConfirmUpdateOrder = z.infer<typeof ConfirmUpdateOrderSchema>;
